














import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import TabbedNav from '@front-app/components/tabs/TabbedNav.vue';
import { useTabbedNav } from '@front-app/components/tabs/useTabbedNav';
import { Routes } from '@front-app/constants/routes';
import { defineComponent } from '@vue/composition-api';

enum CsrTabs {
	COMMUNITY_MANAGEMENT = 'community_management',
	CHANNEL_REPORTS = 'channel_reports',
}

const ROUTE_TO_TAB: {[key: string]: string} = {
	[Routes.COMMUNITY_MANAGEMENT]: CsrTabs.COMMUNITY_MANAGEMENT,
	[Routes.CHANNEL_REPORTS]: CsrTabs.CHANNEL_REPORTS,
	[Routes.CHANNEL_REPORTS_FOR_EVENT]: CsrTabs.CHANNEL_REPORTS,
};

const TAB_BUTTONS: ButtonNavButton[] = [
	{
		key: CsrTabs.COMMUNITY_MANAGEMENT,
		id: CsrTabs.COMMUNITY_MANAGEMENT,
		label: 'page.title.community-management',
		to: { name: Routes.COMMUNITY_MANAGEMENT },
	},
	{
		key: CsrTabs.CHANNEL_REPORTS,
		id: CsrTabs.CHANNEL_REPORTS,
		label: 'page.title.csr-queries',
		to: { name: Routes.CHANNEL_REPORTS },
	},
];

export default defineComponent({
	components: {
		ColumnContainer,
		PaddedContent,
		TabbedNav,
	},
	setup(props, ctx) {
		// Tabs
		const {
			tabButtons,
			currentTabKey,
		} = useTabbedNav(ctx, TAB_BUTTONS, ROUTE_TO_TAB);
		// END Tabs

		return {
			tabButtons,
			currentTabKey,
		};
	},
});
